import React from "react";
import "./hrline.css";

const Hrline = () => {
  return <div className="hrblue"></div>;
};

export default Hrline;
